export const APP_NAME = 'buttonup';
export const APP_DESCRIPTION =
  'Professional Fashion Photos, Without the Photoshoot.';
